import type { ServiceGroupDefinition } from "@App/utils/groupServices";

/**
 * The category grouping for Mahle's service selection.
 * Group order is display order, chosen so the likeliest bookings sit at the top.
 */
export const mahleServiceGroups: ServiceGroupDefinition[] = [
  {
    label: "Wartung",
    serviceIds: [
      13, // Inspektion
      12, // Ölwechsel
      14, // Zahnriemenwechsel
      162, // Getriebeölwechsel
      88, // Getriebeölspülung
    ],
  },
  {
    label: "Reifen",
    serviceIds: [
      1, // Radwechsel
      100, // Räderwechsel: Bestehende Einlagerung
    ],
  },
  {
    label: "Prüfungen & Checks",
    serviceIds: [
      132, // HU/AU („TÜV")
      164, // Fahrzeug-/Sicherheits-Check
    ],
  },
  {
    label: "Bremsen",
    serviceIds: [
      15, // Bremsscheiben- und Belagwechsel
      43, // Bremsbelagwechsel
    ],
  },
  {
    label: "Klima & Heizung",
    serviceIds: [
      136, // Klimaservice
      161, // Klimaanlagen-Reparatur
      160, // Klimaanlagen-Desinfektion
    ],
  },
  {
    label: "Glas",
    serviceIds: [
      34, // Autoglas Reparatur
    ],
  },
  {
    label: "Motor & Antrieb",
    serviceIds: [
      118, // Kupplungswechsel
      165, // Motorinstandsetzung
    ],
  },
  {
    label: "Elektrik / Elektronik & Diagnose",
    serviceIds: [
      10, // Fehlerspeicher auslesen
    ],
  },
  {
    label: "Assistenzsysteme & Sensorik",
    serviceIds: [
      149, // ADAS Kalibrierung
    ],
  },
  {
    label: "E-Mobilität",
    serviceIds: [
      105, // E-Auto Batterie Diagnose (SoH)
    ],
  },
];
